/**
 * Hinterland: random hover photo on product cards (mouse only).
 * Cards render up to five photos (snippets/card-gallery.liquid). CSS keeps photos 2–5 display: none
 * (so lazy loading skips them) except the one marked [data-hl-hover], which crossfades in on hover
 * (snippets/hl-card-styles.liquid). This script marks one of photos 2–5 at random on each card, and
 * a different one each time the mouse leaves (never the first, never the one just shown). So each
 * card downloads one hover photo, as before, only when it's near the screen.
 * Without JavaScript a <noscript> style in snippets/scripts.liquid shows the second photo instead.
 */

const FADE_MS = 350;

/** @param {Element} gallery */
function pick(gallery) {
  // Variant photos Horizon hides on the card ([hidden]) aren't part of the draw.
  const slides = [...gallery.querySelectorAll('slideshow-slide:not([hidden])')];
  const current = slides.findIndex((slide) => slide.hasAttribute('data-hl-hover'));
  const choices = slides.filter((slide, index) => index > 0 && index !== current);
  if (choices.length === 0) return;

  const next = choices[Math.floor(Math.random() * choices.length)];
  for (const slide of gallery.querySelectorAll('slideshow-slide[data-hl-hover]')) {
    slide.removeAttribute('data-hl-hover');
  }
  next?.setAttribute('data-hl-hover', '');
}

/** First pick for cards not seen yet (the page's cards, then "Show more" and search results). */
function pickNewCards() {
  for (const gallery of document.querySelectorAll('product-card .card-gallery:not([data-hl-picked])')) {
    gallery.setAttribute('data-hl-picked', '');
    pick(gallery);
  }
}

pickNewCards();

// Batched to one check per frame, and only when nodes are added.
let queued = false;
new MutationObserver((records) => {
  if (queued || !records.some((record) => record.addedNodes.length > 0)) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    pickNewCards();
  });
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('pointerout', (event) => {
  if (event.pointerType !== 'mouse') return;
  const gallery = event.target instanceof Element ? event.target.closest('product-card .card-gallery') : null;
  if (!gallery) return;
  if (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget)) return;

  // Let the current photo fade out first; skip if the pointer came straight back.
  window.setTimeout(() => {
    if (!gallery.matches(':hover')) pick(gallery);
  }, FADE_MS);
});
